import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Key } from "lucide-react";
import Input from "../../../../empreenderUI/ui/Input";
import Switch from "../../../../empreenderUI/ui/Switch";
import { ActionBar } from "../../../../empreenderUI/ui/ActionBar";
import { useBlockNavigation } from "../../../../empreenderUI/ui/NavigationBlocker";
import { translations } from "../../../../utils/language";

const SegurancaPage = () => {
	const dispatch = useDispatch();
	const controlConfig = useSelector((state) => state.reducerControlConfig);
	const config = useSelector((state) => state.reducerTemplate);
	const language = useSelector((state) => state.reducerLanguage);
	const saved = config?.data?.[0];

	useEffect(() => {
		dispatch({ type: "SAGA_GET_TEMPLATES" });
	}, [dispatch]);

	const isUnlimited = controlConfig.available_time === 0 || controlConfig.available_time === "0";

	const isDirty = useMemo(() => {
		if (!saved) return false;
		return String(controlConfig.available_time ?? "") !== String(saved.available_time ?? "");
	}, [controlConfig.available_time, saved]);

	useBlockNavigation(isDirty);

	const saveConfig = () => {
		dispatch({
			type: "SAGA_UPDATE_TEMPLATE",
			payload: {
				id: controlConfig?.id,
				available_time: controlConfig.available_time,
			},
		});
	};

	const discardChanges = () => {
		dispatch({ type: "SAGA_GET_TEMPLATES" });
	};

	return (
		<div className="mx-auto w-full max-w-2xl px-4 py-6 md:px-6">
			<div className="mb-6">
				<h1 className="text-xl font-semibold tracking-tight text-slate-900">
					{translations["thema-seguranca"]?.[language.data] || "Segurança"}
				</h1>
				<p className="mt-1 text-sm text-gray-500">
					{translations["thema-seguranca-desc"]?.[language.data] ||
						"Defina por quanto tempo os downloads ficam disponíveis."}
				</p>
			</div>

			<div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
				<div className="flex items-start gap-3 border-b border-gray-200 bg-gray-50 px-4 py-3.5">
					<div className="flex size-9 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-700">
						<Key size={16} />
					</div>
					<div className="min-w-0">
						<p className="text-sm font-semibold text-slate-800">
							{translations["thema-seguranca"]?.[language.data] || "Segurança"}
						</p>
						<p className="text-xs text-gray-500">
							{translations["thema-seguranca-desc"]?.[language.data] ||
								"Defina por quanto tempo os downloads ficam disponíveis."}
						</p>
					</div>
				</div>

				<div className="flex flex-col gap-4 px-4 py-4">
					<div className="flex flex-col gap-1.5">
						<label className="text-sm font-semibold text-slate-800">
							{translations["thema-tempo-disponivel"]?.[language.data] || "Tempo disponível"} (
							{translations["thema-dias"]?.[language.data] || "dias"})
						</label>
						{!isUnlimited && (
							<Input
								type="number"
								min="1"
								className="!border !border-solid !border-gray-200 !bg-white"
								value={controlConfig.available_time ?? ""}
								placeholder={translations["seguranca-placeholder"][language.data]}
								onChange={(e) =>
									dispatch({
										type: "CONFIG_CONTROL_SET",
										payload: {
											available_time: e.target.value === "" ? "" : Number(e.target.value),
										},
									})
								}
							/>
						)}
					</div>

					<div className="flex flex-row items-center justify-between gap-3 rounded-md border border-gray-200 px-3 py-2.5">
						<label className="text-sm font-medium text-slate-800">
							{translations["thema-ilimitado"]?.[language.data] || "Ilimitado"}
						</label>
						<Switch
							checked={isUnlimited}
							onCheckedChange={(checked) =>
								dispatch({
									type: "CONFIG_CONTROL_SET",
									payload: { available_time: checked ? 0 : 30 },
								})
							}
						/>
					</div>
				</div>
			</div>

			<ActionBar
				open={isDirty}
				textos={{
					mainText: translations["thema-cuidado-salvar"]?.[language.data],
				}}
				onSave={(proceed) => {
					saveConfig();
					proceed();
				}}
				onCancel={discardChanges}
			/>
		</div>
	);
};

export default SegurancaPage;
